export default {
  SET_VESSEL_INFO(state, data) {
    state.vesselInfo = data
  },
  SET_OWN_VESSELS(state, data) {
    state.ownVessels = data
  },
  SET_MANEUVERING_VERSION(state, data) {
    state.maneuveringVersion = data
  },
  SET_ENGINE_VERSION(state, data) {
    state.engineVersion = data
  },
  SET_ALERT_VERSION(state, data) {
    state.alertVersion = data
  },
  SET_CHANNEL_MASTER(state, data) {
    state.channelMaster = data
  },
  RESET_STATE(state, data) {
    Object.assign(state, data);
  }
};
